import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Grid,
  Alert,
  Button,
} from '@mui/material';
import {
  Flight as FlightIcon,
  People as UsersIcon,
  Place as StationsIcon,
  Settings as SettingsIcon,
  AdminPanelSettings as AdminIcon,
  Route as RouteIcon,
} from '@mui/icons-material';

const adminModules = [
  {
    title: 'Equipos / Aeronaves',
    description: 'Configurar aeronaves, posiciones de carga y capacidades',
    icon: <FlightIcon sx={{ fontSize: 48 }} />,
    path: '/admin/equipos',
    color: '#1565C0',
  },
  {
    title: 'Rutas',
    description: 'Configurar rutas de vuelo con escalas y capacidades',
    icon: <RouteIcon sx={{ fontSize: 48 }} />,
    path: '/admin/rutas',
    color: '#E65100',
  },
  {
    title: 'Usuarios',
    description: 'Gestionar usuarios, roles y permisos',
    icon: <UsersIcon sx={{ fontSize: 48 }} />,
    path: '/admin/usuarios',
    color: '#7B1FA2',
  },
  {
    title: 'Estaciones',
    description: 'Administrar destinos y estaciones',
    icon: <StationsIcon sx={{ fontSize: 48 }} />,
    path: '/admin/estaciones',
    color: '#2E7D32',
  },
];

const AdminIndex = () => {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Alert severity="error" sx={{ maxWidth: 400, mx: 'auto', mb: 3 }}>
          No tiene permisos para acceder a esta sección. Solo administradores.
        </Alert>
        <Button component={Link} to="/vuelos" variant="contained">
          Volver al Inicio
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      {/* Header */}
      <Card
        sx={{
          mb: 4,
          background: 'linear-gradient(135deg, #37474F 0%, #263238 100%)',
          color: 'white',
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <AdminIcon sx={{ fontSize: 48 }} />
            <Box>
              <Typography variant="h4" fontWeight="bold">
                Administración del Sistema
              </Typography>
              <Typography sx={{ opacity: 0.9 }}>
                Configuración y gestión de recursos del sistema
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>

      {/* Modules */}
      <Grid container spacing={3}>
        {adminModules.map((module) => (
          <Grid item xs={12} sm={6} md={4} key={module.path}>
            <Card
              sx={{
                height: '100%',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6,
                },
              }}
            >
              <CardActionArea
                component={Link}
                to={module.path}
                sx={{ height: '100%', p: 3 }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                    gap: 2,
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      borderRadius: 3,
                      bgcolor: `${module.color}15`,
                      color: module.color,
                    }}
                  >
                    {module.icon}
                  </Box>
                  <Box>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {module.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {module.description}
                    </Typography>
                  </Box>
                </Box>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdminIndex;





